import React from 'react';
import { Card, Button, Badge, ListGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faUser, faCircle } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import ClassService from './classes/ClassService';
import BookingService from './bookings/BookingService';
import { useState, useEffect } from 'react';
const convertDateFromArray = dateArray => {
  const [year, month, day] = dateArray;
  return `${day}/${month}/${year}`;
};
const isCancellationTooLate = (date, time, cancellationPolicyHours) => {
  const eventDateTime = new Date(`${date}T${time}`);
  const now = new Date();
  const hoursDifference = (eventDateTime - now) / (1000 * 60 * 60);
  return hoursDifference < cancellationPolicyHours;
};
const UpcomingClassesCard = () => {
  const [upcomingClasses, setUpcomingClasses] = useState();
  const handleLeaveWaitlist = classItem => {
    // Here you would call your booking service to leave the waitlist
    console.log(
      `Leaving waitlist for class: ${classItem.identifier} -  ${classItem.name} at ${classItem.time} on ${classItem.date}`
    );
    ClassService.leaveWaitlist({ identifier: classItem.identifier })
      .then(response => {
        console.log('Left waitlist successfully:', response);
        refreshBookings(); // Refresh the events after leaving the waitlist
      })
      .catch(error => {
        console.error('Error leaving waitlist:', error);
      });
  };
  const refreshBookings = async () => {
    try {
      const data = await BookingService.retrieveUpcomingBookingsByUser();
      const profile = JSON.parse(localStorage.getItem('profile'));

      const updatedData = data.map(n => {
        const time = new Date(n.startTime).toLocaleDateString();
        const date = convertDateFromArray(n.date);

        // Check if user is on the waitlist
        const isOnWaitlist =
          n.waitlisted &&
          n.waitlisted.some(w => w.identifier === profile.identifier);
        const waitlistPosition = isOnWaitlist
          ? n.waitlisted.findIndex(w => w.identifier === profile.identifier) + 1
          : null;
        console.log(
          `Class: ${n.name}, Waitlist Position: ${waitlistPosition}, Is on Waitlist: ${isOnWaitlist}`
        );
        return {
          ...n,
          id: n.identifier,
          time: n.startTime,
          type: n.name,
          date: date,
          status: isOnWaitlist ? 'waitlist' : 'booked',
          position: waitlistPosition,
          spotsLeft: n.maxCapacity - (n.attendees ? n.attendees.length : 0)
        };
      });
      setUpcomingClasses(updatedData);
    } catch (error) {
      console.error('Error fetching upcoming bookings:', error);
    }
  };
  const handleCancelBooking = classItem => {
    // Here you would call your booking service to cancel the booking
    console.log(
      `Canceling booking for class: ${classItem.identifier} -  ${classItem.name} at ${classItem.time} on ${classItem.date}`
    );
    if (
      isCancellationTooLate(
        classItem.date,
        classItem.time,
        classItem.cancellationPolicyHours
      )
    ) {
      console.error('Cancellation is too late');
      return;
    }
    ClassService.cancelBooking({ identifier: classItem.identifier })
      .then(response => {
        console.log('Booking canceled successfully:', response);
        refreshBookings(); // Refresh the events after canceling
      })
      .catch(error => {
        console.error('Error canceling booking:', error);
      });
    // For now, we'll just log the action and close the modal
  };
  const navigate = useNavigate();
  const getStatusBadge = classItem => {
    if (classItem.status === 'booked') {
      return (
        <Badge bg="success" className="ms-2">
          Booked
        </Badge>
      );
    } else if (classItem.status === 'waitlist') {
      return (
        <Badge bg="warning" text="dark" className="ms-2">
          Waitlist #{classItem.position}
        </Badge>
      );
    }
    return null;
  };

  useEffect(() => {
    refreshBookings();
  }, []);

  return (
    <Card className="h-100 border-0 shadow-sm">
      <Card.Header className="bg-transparent border-bottom border-secondary">
        <h5 className="mb-0 fw-bold">Upcoming Classes</h5>
      </Card.Header>
      <Card.Body className="p-0">
        {upcomingClasses && upcomingClasses.length === 0 && (
          <div className="text-center p-3 text-white-50">
            No upcoming classes booked.
          </div>
        )}
        <ListGroup variant="flush">
          {upcomingClasses?.slice(0, 4).map(classItem => (
            <ListGroup.Item
              key={classItem.id}
              className="border-secondary p-3 hover-bg-secondary wod-dark-card"
              style={{ cursor: 'pointer', transition: 'background-color 0.2s' }}
            >
              <div className="d-flex justify-content-between align-items-start mb-2">
                <div>
                  <div className="fw-bold mb-1">{classItem.type}</div>
                  <small className="">
                    <FontAwesomeIcon icon={faClock} className="me-1" />
                    {classItem.date} at {classItem.time}
                  </small>
                </div>
                {getStatusBadge(classItem)}
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <small>
                  <FontAwesomeIcon icon={faUser} className="me-1" />
                  {classItem.coach}
                </small>
                <div>
                  {classItem.status === 'booked' && (
                    <>
                      <Button
                        size="sm"
                        variant="outline-danger"
                        className="me-1"
                        onClick={() => handleCancelBooking(classItem)}
                      >
                        Cancel
                      </Button>
                      <small className="text-success">
                        <FontAwesomeIcon icon={faCircle} className="me-1" />
                        {classItem.spotsLeft} spots left
                      </small>
                    </>
                  )}
                  {classItem.status === 'waitlist' && (
                    <Button
                      size="sm"
                      variant="outline-warning"
                      onClick={() => handleLeaveWaitlist(classItem)}
                    >
                      Leave Waitlist
                    </Button>
                  )}
                </div>
              </div>
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Card.Body>
      <Card.Footer className="bg-transparent border-top border-secondary text-center">
        <Button variant="link" onClick={() => navigate('/app/wod/timetable')}>
          View All Classes →
        </Button>
      </Card.Footer>
    </Card>
  );
};

export default UpcomingClassesCard;
